/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { LearnSectionFragment } from "@cosmos/hygraph-schema";
import { useState } from "react";

import {
	ResponsiveContainer,
	SectionHeading,
	BackgroundContainer,
	Categories,
	CategoryProps,
	SectionContainer,
	TabList,
} from "@components/elements";
import { VStack } from "@panda/jsx";
import { css } from "@panda/css";

export function LearnSection({
	config,
	categories,
	tabs = [],
	applicationFamily,
}: LearnSectionFragment): React.JSX.Element | null {
	const [tab, setTab] = useState<string>(tabs[0]?.value);
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(categories?.length || tabs?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer>
					<VStack alignItems="stretch" gap="eds.dimension.24" className="hydrus-column-list-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							<VStack
								alignItems="stretch"
								gap="eds.dimension.48"
								className={css({ lgDown: { gap: "eds.dimension.40" } })}
							>
								<TabList tabs={tabs} onchange={(value) => setTab(value)} />
								<Categories
									applicationFamily={applicationFamily}
									activeTab={tab}
									categories={categories as CategoryProps[]}
								/>
							</VStack>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
}
